/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Button, Layout, Popover, Space, theme } from 'antd';
import { useAppDispatch, useAuthState } from '@core/.';
import { logout } from '@core/features/auth/thunks';
import { LoadingOutlined, LogoutOutlined } from '@ant-design/icons';
import { AuthUser } from '@core/models';
import { fetchReviews } from '@core/features/review/thunks';
import { fetchReviewRequests } from '@core/features/review-request/thunks';
import SelectBusinessButotn from '@components/SelectBusinessButton';
import { ConnectFacebookButton } from '..';

type Props = {};

const AppBar = (props: Props) => {
  const { user } = useAuthState();
  const dispatch = useAppDispatch();
  const {
    token: { colorBgContainer, colorBorder },
  } = theme.useToken();

  const handleLogout = () => {
    dispatch(logout());
  };

  const hoverContent = (user: AuthUser) => (
    <div>
      <h3>{`${user.given_name} ${user.family_name}`}</h3>
      <p>{`${user.email}`}</p>
      <Space direction="vertical" style={{ marginTop: 20 }}>
        <ConnectFacebookButton />
        {/* <ConnectInstagramButton /> */}
        <Button style={{ width: '100%', color: 'red' }} onClick={handleLogout}>
          <LogoutOutlined />
          Logout
        </Button>
      </Space>
    </div>
  );

  useEffect(() => {
    const init = async () => {
      await dispatch(fetchReviews());
      await dispatch(fetchReviewRequests());
    };
    init();
  }, []);

  return (
    <Layout.Header
      style={{
        padding: '10px 20px',
        background: colorBgContainer,
        borderBottom: `1px solid ${colorBorder}`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}>
      {user ? (
        <React.Fragment>
          <SelectBusinessButotn />
          <Popover content={hoverContent(user)}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
              }}>
              <img
                referrerPolicy="no-referrer"
                style={{ width: 35, borderRadius: 50 }}
                src={user.picture}
                alt={user.picture}
              />
              <div style={{ marginLeft: 10 }}>
                <h4>{`${user.given_name} ${user.family_name}`}</h4>
              </div>
            </div>
          </Popover>
        </React.Fragment>
      ) : (
        <LoadingOutlined />
      )}
    </Layout.Header>
  );
};

export default AppBar;
